module.exports = __webpack_public_path__ + "static/media/svetoslav-400-400.7949656c.png";